module.exports = __webpack_public_path__ + "img/e_3_13_g.ee23ae2f.png";